import type { EmblaOptionsType } from 'embla-carousel';
import styled, { css } from 'styled-components';
import {
  EMBLA_CAROUSEL_CONFIG,
  getContainerMarginLeft,
  getGroupJustifyContent,
  getSlideFlex,
  getSlidePaddingLeft,
} from './helpers';

interface IScEmblaCarouselProps {
  $slidesPerView?: number;
  $spaceBetween?: number;
  $reservePaginationSpace?: boolean;
  $grouped?: boolean;
  $align?: EmblaOptionsType['align'];
}

export const ScEmblaCarousel = styled.div<IScEmblaCarouselProps>`
  position: relative;
  z-index: 3;
  width: 100%;
  transition: height ${EMBLA_CAROUSEL_CONFIG.heightTransitionDuration}
    ease-out;

  ${({ $reservePaginationSpace }) =>
    $reservePaginationSpace &&
    css`
      padding-bottom: ${EMBLA_CAROUSEL_CONFIG.paginationSpace};
    `}

  .embla__viewport {
    overflow: hidden;
    width: 100%;
    max-width: 100%;
    padding: 0 ${EMBLA_CAROUSEL_CONFIG.viewportPadding};
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }

  .embla__container {
    display: flex;
    touch-action: pan-y pinch-zoom;
    margin-left: ${({ $grouped, $spaceBetween }) =>
      getContainerMarginLeft($grouped, $spaceBetween)};
  }

  .embla__slide {
    min-width: 0;
    padding-left: ${({ $grouped, $spaceBetween }) =>
      getSlidePaddingLeft($grouped, $spaceBetween)};
    flex: ${({ $grouped, $slidesPerView }) =>
      getSlideFlex($grouped, $slidesPerView)};

    img {
      -webkit-user-drag: none;
      user-select: none;
    }
  }

  .embla__group {
    display: flex;
    justify-content: ${({ $align }) => getGroupJustifyContent($align)};
    width: 100%;
  }
`;
